import { z } from "zod";

export const zipCodeSchema = z.object({
	zipCode: z.string().min(5).max(5),
});
